import React, {Component, Fragment} from "react";
import {Row} from "react-materialize";
import UploadFile from "../../components/applicationComponents/uploadFile";

class FileUpload extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        return (
            <div>
                <Row>
                    <Fragment>
                        <Row
                            className={this.state.isLoaded ? "card-container" : "card-container loader-wait"}
                        >
                            <UploadFile history={this.props.history}/>
                        </Row>
                    </Fragment>
                </Row>
            </div>
        );
    }
}

export default FileUpload;
